import React, { useState, useEffect } from "react";
import { isEmptyArray } from "../../utils/common-function";
export function useSelectItem(key, defaultSelect = []) {
  const [SelectedItems, setSelectedSelectedItems] = useState([]);
  useEffect(() => {
    if (isEmptyArray(defaultSelect)) return;
    setSelectedSelectedItems(defaultSelect);
  }, [defaultSelect, key]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedSelectedItems((prev) => [...prev, row[key]]);
    } else {
      setSelectedSelectedItems((prev) => prev.filter((x) => x !== row[key]));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedSelectedItems(rows.map((el) => el[key]));
    } else {
      setSelectedSelectedItems([]);
    }
  };

  const setSelectedItems = (rows) => {
    if (Array.isArray(rows)) {
      setSelectedSelectedItems(rows.map((el) => el[key]));
    }
  };

  return {
    SelectedItems,
    handleOnSelect,
    handleOnSelectAll,
    setSelectedItems,
  };
}
